/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import e from"react";import{useLatestValue as t}from"./use-latest-value.js";let r=function(r){let a=t(r);return e.useCallback(((...e)=>a.current(...e)),[a])};export{r as useEvent};
//# sourceMappingURL=use-event.js.map
